module.exports = __webpack_public_path__ + "static/media/outline-account_balance_wallet-24px.fb37a046.svg";